import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import authService from '../../services/authService';
import LoadingOverlay from '../../components/loading/loading';
import './style.scss';

const LoginPage = (props) => {

    const push = useNavigate()

    const [value, setValue] = useState({
        username: '',
        password: '',
        remember: false,
    });

    const [loading, setLoading] = useState(false);

    const changeHandler = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
        validator.showMessages();
    };

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const submitForm = async (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setLoading(true);
            setValue({
                username: '',
                password: '',
                remember: false,
            });
            validator.hideMessages();

            const { username, password } = value;

            try {
                const userData = { username, password };
                const result = await authService.users(userData, "login");
                if (result && !result.success) {
                    toast.error(result.displayMessage);
                    return;
                }
                sessionStorage.setItem('isLoggedIn', 'true');
                sessionStorage.setItem('userId', result.userId);
                sessionStorage.setItem('isAdmin', result.isAdmin);
                sessionStorage.setItem('token', result.token);
                toast.success(result.message);
                push(result.isAdmin ? '/admin/dashboard' : '/');
            } catch (error) {
                toast.error('An error occurred during login.');
            } finally {
                setLoading(false);
            }
        } else {
            validator.showMessages();
            toast.error('Empty fields are not allowed!');
        }
    };
    return (
        <Grid className="loginWrapper">
            {loading && <LoadingOverlay />}
            <Grid className="loginForm">
                <h2>Sign In</h2>
                <p>Sign in to your account</p>
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="johndoe / 12345678"
                                value={value.username}
                                variant="outlined"
                                name="username"
                                label="Username / Phone Number"
                                autoComplete="username"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('username', value.username, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="********"
                                value={value.password}
                                variant="outlined"
                                name="password"
                                type="password"
                                label="Password"
                                autoComplete="current-password"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('password', value.password, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formAction">
                                <Link to="/forgot-password">Forgot Password?</Link>
                            </Grid>
                            <Grid className="formFooter">
                                <Button fullWidth className="cBtnTheme" type="submit">Login</Button>
                            </Grid>
                            <p className="noteHelp">Don't have an account? <Link to="/signup">Create free account</Link></p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                    <i className="fi flaticon-honeycomb"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default LoginPage;